import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-recipe-bom",
  "use": "icon-soc-l1-recipe-bom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-recipe-bom\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M224 192h448v640H224V192zm64 64v512h320V256H288z\" />\r\n  <path d=\"M352 320h192v48H352v-48zm0 96h192v48H352v-48zm0 96h128v48H352v-48z\" />\r\n  <path d=\"M704 320h128v64H704v-64zm-32 128h160v288H672V448z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-recipe-bom.svg
// module id = pdWz
// module chunks = 546